module.exports = __webpack_public_path__ + "img/qr-code-icon.fd29e0df.png";